import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';

const TAB_TRIGGER = 'data-[state=active]:bg-[#00FF00] data-[state=active]:text-black';

/**
 * "Room Information" Card — Overview / Hints / AI Analysis tabs.
 * AI Analysis tab only renders when an analysis result is available.
 */
export const RoomInfoTabs = ({ room, aiAnalysis }) => (
  <Card className="bg-[#1A1A1A] border-gray-800" data-testid="room-info-card">
    <CardHeader>
      <CardTitle className="text-white">Room Information</CardTitle>
    </CardHeader>
    <CardContent>
      <Tabs defaultValue="overview" className="w-full">
        <TabsList className="bg-[#0A0A0A] border-gray-800">
          <TabsTrigger value="overview" className={TAB_TRIGGER}>Overview</TabsTrigger>
          <TabsTrigger value="hints" className={TAB_TRIGGER}>Hints</TabsTrigger>
          {aiAnalysis && (
            <TabsTrigger value="ai" className={TAB_TRIGGER}>AI Analysis</TabsTrigger>
          )}
        </TabsList>

        <TabsContent value="overview" className="text-gray-300 space-y-4">
          <div>
            <h3 className="font-semibold text-white mb-2">Learning Objectives</h3>
            <ul className="list-disc list-inside space-y-1 text-sm">
              <li>Understanding {room.category || 'cybersecurity'} fundamentals</li>
              <li>File system navigation and permissions</li>
              <li>Finding and analyzing sensitive data</li>
              <li>Security assessment techniques</li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold text-white mb-2">Category</h3>
            <p className="text-sm">{room.category || 'General Security'}</p>
          </div>
        </TabsContent>

        <TabsContent value="hints" className="text-gray-300 space-y-2">
          <div className="bg-[#0A0A0A] border border-gray-800 rounded p-3">
            <p className="text-sm">
              <strong className="text-white">Hint 1:</strong> Try using the &quot;ls&quot; command to list files
            </p>
          </div>
          <div className="bg-[#0A0A0A] border border-gray-800 rounded p-3">
            <p className="text-sm">
              <strong className="text-white">Hint 2:</strong> Use &quot;cat&quot; to read file contents
            </p>
          </div>
          <div className="bg-[#0A0A0A] border border-gray-800 rounded p-3">
            <p className="text-sm">
              <strong className="text-white">Hint 3:</strong> Submit flags using the format flag{'{...}'}
            </p>
          </div>
        </TabsContent>

        {aiAnalysis && (
          <TabsContent value="ai" className="text-gray-300">
            <div className="bg-[#0A0A0A] border border-[#00BFFF]/30 rounded p-4">
              <h3 className="font-semibold text-[#00BFFF] mb-2">AI Threat Analysis</h3>
              <p className="text-sm whitespace-pre-wrap">{aiAnalysis}</p>
            </div>
          </TabsContent>
        )}
      </Tabs>
    </CardContent>
  </Card>
);
